var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 19,
    viewBox: "0 0 13 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.35897C12 9.31832 6.5 17.6724 6.5 17.6724C6.5 17.6724 1 9.31832 1 6.35897C1 3.39963 3.46278 1 6.5 1C9.53722 1 12 3.39963 12 6.35897Z",
    stroke: "#535353",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50008 7.54994C7.5126 7.54994 8.33341 6.75018 8.33341 5.76362C8.33341 4.77706 7.5126 3.97729 6.50008 3.97729C5.48756 3.97729 4.66675 4.77706 4.66675 5.76362C4.66675 6.75018 5.48756 7.54994 6.50008 7.54994Z",
    stroke: "#535353",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationBlack);
export default __webpack_public_path__ + "static/media/LocationBlack.053bea4f20314a77c1b6906df47d59e4.svg";
export { ForwardRef as ReactComponent };